import React, { Component, PropsWithChildren } from 'react';
import { utils as hlUtils } from '../';
// tslint:disable-next-line:no-var-requires
const ContentLoader = require('react-content-loader').default;
import { ISkeletonContainerProps } from './types';

export class SkeletonContainer extends Component<PropsWithChildren<ISkeletonContainerProps>, {}> {
  public static GenerateId: () => string = () => hlUtils.createId('contentloader');

  private uniqueId = SkeletonContainer.GenerateId();

  public render() {
    const { height, style, width } = this.props;

    // ContentLoader applies width/height props as svg viewbox attribute. Svg is still autosized.
    // Have to set width/height via styles.
    const defaultStyles = { width, height };
    const finalStyles = Object.assign(defaultStyles, style);

    return (
      <ContentLoader
        height={height}
        width={width}
        speed={2}
        primaryColor={'#f3f3f3'}
        secondaryColor={'#ecebeb'}
        style={finalStyles}
        uniquekey={this.uniqueId}
      >
        {this.props.children}
      </ContentLoader>
    );
  }
}
